import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import Layout from "./components/Layout";
import { AddHaulier } from "./pages/AddCustomer";
import { Invoice } from "./pages/Invoice";
import AddRole from "./pages/AddRole";
import EditProfile from "./pages/EditProfile";
import { AddTruck } from "./pages/AddVehicle";
import { Device } from "./pages/Solution";
import About from "./pages/Home";
import { Login } from "./pages/Login";
import { DeviceHistory } from "./pages/DeviceHistory";
import { Register } from "./pages/Register";
import PrivateRoute from "./PrivateRoute";
import { UserRegister } from "./pages/Technicians";
import PermissionManager from "./pages/PermissionManager";
import ResetPassword from "./pages/ResetPassword";
import { SalesNewInstallation } from "./pages/SalesNewInstallation";
import CustomerSupport from "./pages/CustomerSupport";
import ProductionPage from "./pages/ProductionPage";
import StorePage from "./pages/StorePage";
import TechnicalPage from "./pages/TechnicalPage";
import CollectionRecoveryPage from "./pages/CollectionRecoveryPage";
import CollectionRecoveryHistoryPage from "./pages/CollectionRecoveryHistoryPage";
import { AddSale } from "./pages/AddSale";
import { AddTechnician } from "./pages/AddTechnician";
import { AddCustomerForm } from "./pages/AddCustomerForm";
import { AddVehicleForm } from "./pages/AddVehicleForm";
import { AddCustomerComplaint } from "./pages/AddCustomerComplaint";
import { EditSale } from "./pages/EditSale";
import { EditCustomerForm } from "./pages/EditCustomerForm";
import { EditVehicleForm } from "./pages/EditVehicleForm";
import { EditCustomerComplaint } from "./pages/EditCustomerComplaint";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<About />} />
          <Route path="technicians" element={<UserRegister />} />
          <Route path="sales-new-installation" element={<SalesNewInstallation />} />
          <Route path="add-customer" element={<AddHaulier />} />
          <Route path="invoice" element={<Invoice />} />
          <Route path="add-roles" element={<AddRole />} />
          <Route path="edit-profile" element={<EditProfile />} />
          <Route path="add-truck" element={<AddTruck />} />
          <Route path="add-device" element={<Device />} />
          <Route path="device-history" element={<DeviceHistory />} />
          <Route path="manage-permissions" element={<PermissionManager />} />

          {/* Unified pages */}
          <Route path="customer-support" element={<CustomerSupport />} />
          <Route path="production" element={<ProductionPage />} />
          <Route path="store" element={<StorePage />} />
          <Route path="technical" element={<TechnicalPage />} />
          <Route path="collection-recovery" element={<CollectionRecoveryPage />} />
          <Route path="collection-recovery-history" element={<CollectionRecoveryHistoryPage />} />

          {/* Standalone add-record pages */}
          <Route path="sales-new-installation/add" element={<AddSale />} />
          <Route path="technicians/add" element={<AddTechnician />} />
          <Route path="add-customer/new" element={<AddCustomerForm />} />
          <Route path="add-truck/new" element={<AddVehicleForm />} />
          <Route path="customer-support-complaint/add" element={<AddCustomerComplaint />} />

          {/* Standalone edit-record pages */}
          <Route path="sales-new-installation/edit/:id" element={<EditSale />} />
          <Route path="add-customer/edit/:id" element={<EditCustomerForm />} />
          <Route path="add-truck/edit/:id" element={<EditVehicleForm />} />
          <Route path="customer-support-complaint/edit/:id" element={<EditCustomerComplaint />} />

          {/* Legacy redirects */}
          <Route path="customer-support-new-installation" element={<Navigate to="/customer-support" replace />} />
          <Route path="customer-support-complaint" element={<Navigate to="/customer-support" replace />} />
          <Route path="customer-support-removal-transfer" element={<Navigate to="/customer-support" replace />} />
          <Route path="customer-support-repair-replacement" element={<Navigate to="/customer-support" replace />} />
          <Route path="production-repair-replacement" element={<Navigate to="/production" replace />} />
          <Route path="dispatch" element={<Navigate to="/store" replace />} />
          <Route path="dispatch-repair-replacement" element={<Navigate to="/store" replace />} />
          <Route path="technical-new-installation" element={<Navigate to="/technical" replace />} />
          <Route path="technical-complaint" element={<Navigate to="/technical" replace />} />
          <Route path="technical-removal-transfer" element={<Navigate to="/technical" replace />} />
          <Route path="technical-repair-replacement" element={<Navigate to="/technical" replace />} />
          <Route path="sales-coordinator-new-installation" element={<Navigate to="/collection-recovery" replace />} />
          <Route path="sales-coordinator-removal-transfer" element={<Navigate to="/collection-recovery" replace />} />
          <Route path="sales-coordinator-repair-replacement" element={<Navigate to="/collection-recovery" replace />} />
          <Route path="installation-history" element={<Navigate to="/collection-recovery-history" replace />} />
        </Route>
      </Routes>
    </Router>
    </ThemeProvider>
  );
}
